import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import useIcons from '../../hooks/useIcons';
import { WrapperDefault } from '../Shared/Shared';

export const FormSelectWrapper = styled(WrapperDefault)``;

export const SelectContainer = styled.select.attrs(() => {
  const icons = useIcons();
  return {
    icon: icons.chevronDown?.childImageSharp?.gatsbyImageData?.images?.fallback?.src
  };
})<{ icon: string }>`
  margin-top: 20px;
  margin-bottom: 10px;
  appearance: none;
  border: 0;
  outline: 0;
  font: inherit;
  height: 50px;
  background: url(${props => props.icon}) no-repeat right;
  color: var(--black);
  border-bottom: 3px solid var(--primary-gray);
  cursor: pointer;
  user-select: none;
  font-size: 18px;
  width: 100%;
  font-weight: 600;
  option {
    color: inherit;
    background-color: var(--white);
  }
  &:focus {
    outline: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: var(--primary-gray)
      border-bottom: none;
      color: var(--text-primary);
      cursor: not-allowed;
    `}
`;
